import React from 'react'
import styled from 'styled-components'

import { breakpoint, getColor } from '../../shared/theme'

import PropTypes from 'prop-types'
import SwiperCore, { A11y, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

SwiperCore.use([Pagination, A11y])

const SliderWrapper = styled.div`
	position: relative;
	margin-top: 48px;

	@media ${breakpoint('tablet')} {
		margin-top: 64px;
		margin-left: 9.35%;
	}

	@media ${breakpoint('desktop')} {
		margin-left: 15.75%;
	}

	.swiper-slide {
		width: 100%;

		@media ${breakpoint('tablet')} {
			width: 53.75%;
		}
	}

	.swiper-pagination {
		display: flex;
		justify-content: center;
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		z-index: 10;
		padding-bottom: 20px;

		&::before {
			content: '';
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 48px;
			background: linear-gradient(
				0deg,
				rgba(0, 0, 0, 0.6) 0%,
				rgba(0, 0, 0, 0) 100%
			);
		}

		span {
			width: 12px;
			height: 12px;
			margin-right: 16px;
			display: inline-block;
			transform: scale(0.666);
			border-radius: 50%;
			background: ${getColor('greyMid')};
			transition: all 200ms ${(props) => props.theme.ease};

			&:last-child {
				margin-right: 0;
			}

			&.swiper-pagination-bullet-active {
				transform: scale(1);
				background: ${getColor('white')};
			}
		}

		@media ${breakpoint('tablet')} {
			visibility: collapse;
		}
	}
`

const OneColumnSlide = styled.div`
	position: relative;
	width: 100%;

	&::before {
		content: '';
		display: block;
		width: 100%;
		padding-top: 86.66%;

		@media ${breakpoint('tablet')} {
			padding-top: 58%;
		}
	}
`

const Image = styled.img``

const OneColumnSlider = ({ slides }) => {
	if (!slides || slides === undefined || slides.length == 0) {
		return null
	}

	return (
		<SliderWrapper>
			<Swiper
				pagination={{ clickable: true }}
				breakpoints={{
					0: {
						slidesPerView: 1,
						spaceBetween: 0,
					},
					640: {
						slidesPerView: 'auto',
						spaceBetween: 40,
					},
				}}
			>
				{slides.map((slide, index) => (
					<SwiperSlide key={index}>
						<OneColumnSlide>
							{slide.image && (
								<Image src={slide.image.mediaItemUrl} className="bg-cover" />
							)}
						</OneColumnSlide>
					</SwiperSlide>
				))}
			</Swiper>
		</SliderWrapper>
	)
}

export default OneColumnSlider

OneColumnSlider.propTypes = {
	slides: PropTypes.array,
}

OneColumnSlider.defaultProps = {
	slides: [],
}
